<script lang="ts" setup>
import { useEventDetailHalf } from '@desktop/views/Relation/Sports/Baseball/composables'

import PitchTitle from '../PitchTitle.vue'
import CurrentBatterSelect from './CurrentBatterSelect.vue'
import CurrentPitcherSelect from './CurrentPitcherSelect.vue'
import PlateAppearanceButton from './PlateAppearanceButton.vue'

const { eventDetailHalfValue } = useEventDetailHalf()
</script>

<template>
  <div>
    <PitchTitle>matchup</PitchTitle>
    <div
      :key="eventDetailHalfValue"
      class="flex flex-col gap-y-3"
    >
      <CurrentPitcherSelect />
      <CurrentBatterSelect />
    </div>
    <PlateAppearanceButton class="my-4" />
  </div>
</template>
